import styles from './Dashboard.module.scss';

export function AnalyticsFooter() {
  return (
    <div className={styles.footerNotes}>
      <span>*</span>previous time calculated on date range filter selection
    </div>
  );
}
